import { CoreMenu } from 'src/@core/types';
import { projectsMenu } from './projects.menu';

export const iTeamMenu: CoreMenu[] = [
  {
    id: 'Monitoring',
    title: 'Employee Monitoring',
    type: 'item',
    icon: 'emp-monitor.svg',
    url: '/i-team/monitoring',
    role: {
      roles: ['employee'],
      right: 'H1057',
    },
  },
  {
    id: 'Weekly-Planner',
    title: 'Weekly Planner',
    type: 'item',
    icon: 'planner.svg',
    url: '/i-team/weekly-planner',
    role: {
      roles: ['employee'],
      right: 'H1048',
    },
  },
  {
    id: 'Dashboard',
    title: 'Reports',
    type: 'collapsible',
    icon: 'report-copy.svg',
    role: {
      roles: ['employee'],
      right: 'H2103',
    },
    children: [
      {
        id: 'Project-wise',
        title: 'Project-wise report',
        type: 'item',
        icon: 'report-copy.svg',
        url: '/i-team/dashboard/project-wise',
        role: {
          roles: ['employee'],
          right: '',
        },
      },
      {
        id: 'Sprint-wise',
        title: 'Sprint-wise report',
        type: 'item',
        icon: 'sprint-wise-report.svg',
        url: '/i-team/dashboard/sprint-wise',
        role: {
          roles: ['employee'],
          right: '', 
        },
      },
      {
        id: 'Sprint-resource-allocation',
        title: 'Sprint Resource Allocation',
        type: 'item',
        icon: 'sprint-resource-allocation.svg',
        url: '/i-team/dashboard/sprint-resource-allocation',
        role: {
          roles: ['employee'],
          right: '',
        },
      },
      {
        id: 'Developer-sprint-report',
        title: 'Developer Sprint Report',
        type: 'item',
        icon: 'developer-sprint-report.svg',
        url: '/i-team/dashboard/developer-sprint-report',
        role: {
          roles: ['employee'],
          right: '',
        },
      },
      {
        id: 'Project-resource-report',
        title: 'Project Resource Report',
        type: 'item',
        icon: 'project-resource-report.svg',
        url: '/i-team/dashboard/project-resource-report',
        role: {
          roles: ['employee'],
          right: '',
        },
      },
      {
        id: 'Sprint-x-matrix',
        title: 'Sprint x Project Matrix',
        type: 'item',
        icon: 'sprint-x-project-matrix.svg',
        url: '/i-team/dashboard/sprint-x-matrix',
        role: {
          roles: ['employee'],
          right: '',
        },
      },
      {
        id: 'Employee-project-breakdown',
        title: 'Employee Project Breakdown',
        type: 'item',
        icon: 'employee-project-breakdown.svg',
        url: '/i-team/dashboard/employee-project-breakdown',
        role: {
          roles: ['employee'],
          right: '',
        },
      },
    ],
  },
  // ...qaMenu,
  ...projectsMenu,
  {
    id: 'Project-Costing',
    title: 'Project Costing',
    type: 'collapsible',
    icon: 'costing-p.svg',
    role: {
      roles: ['employee'],
      right: ['H1054', 'H1055', 'H1056'],
    },
    children: [
      {
        id: 'Employees Costing',
        title: 'Employees Costing',
        type: 'item',
        icon: 'costing-e.svg',
        url: '/i-team/costing/employees',
        role: {
          roles: ['employee'],
          right: ['H1054', 'H1055'],
        },
      },
      {
        id: 'Project Costing',
        title: 'Project Costing',
        type: 'item',
        icon: 'costing-p.svg',
        url: '/i-team/costing/projects',
        role: {
          roles: ['employee'],
          right: 'H1056',
        },
      },
    ],
  },
  {
    exactMatch: true,
    id: 'Performance-Report',
    title: 'Performance Report',
    type: 'collapsible',
    icon: 'performance-review.svg',
    role: {
      roles: ['employee'],
      right: ['F1190', 'F1191'],
    },
    children: [
      {
        exactMatch: true,
        id: 'employee-performance',
        title: 'Employee Performance',
        type: 'item',
        icon: 'employee-performance.svg',
        url: '/i-team/performance/employee',
        role: {
          roles: ['employee'],
          right: 'F1190',
        },
      },
      {
        exactMatch: true,
        id: 'marketing-performance',
        title: 'Marketing Performance',
        type: 'item',
        icon: 'marketing-performance.svg',
        url: '/i-team/performance/marketing',
        role: {
          roles: ['employee'],
          right: 'F1191',
        },
      },
    ],
  },
  {
    id: 'Release-Notes',
    title: 'Release Notes',
    type: 'item',
    icon: 'release-notes.svg',
    url: '/i-team/release-notes',
    role: {
      roles: ['employee'],
      right: 'H1058',
    },
  },
  {
    id: 'Sprint-Settings',
    title: 'Sprint Settings',
    type: 'collapsible',
    icon: 'settings.svg',
    role: {
      roles: ['employee'],
      right: ['H1409', 'H1410'],
    },
    children: [
      {
        id: 'Team',
        title: 'Team',
        type: 'item',
        icon: 'my-team.svg',
        url: '/i-team/sprint-view/team',
        role: {
          roles: ['employee'],
          right: 'H1410',
        },
      },
      {
        id: 'Sprint',
        title: 'Sprint',
        type: 'item',
        icon: 'test-result.svg',
        url: '/i-team/sprint-view/sprint',
        role: {
          roles: ['employee'],
          right: 'H1409',
        },
      },

     
    ],
  },
  // {
  //   id: 'Sprint-Board',
  //   title: 'Sprint Board',
  //   type: 'item',
  //   icon: 'sprint-board.svg',
  //   url: '/i-team/sprint-view/board',
  //   exactMatch: true,
  //   role: {
  //     roles: ['employee'],
  //     right: 'H1365',
  //   },
  // },
  {
    exactMatch: true,
    id: 'Uat',
    title: 'UAT',
    type: 'collapsible',
    icon: 'uat.svg',
    role: {
      roles: ['employee'],
      right: ['H1865', 'H1866'],
    },
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'uat.svg',
        url: '/i-team/uat/dashboard',
        role: {
          roles: ['employee'],
          right: 'H1865',
        },
      },
      {
        id: 'sessions',
        title: 'Sessions',
        type: 'item',
        icon: 'tickets.svg',
        url: '/i-team/uat/sessions',
        role: {
          roles: ['employee'],
          right: 'H1866',
        },
      },
    ],
  },
  {
    id: 'Project-document',
    title: 'Project Document',
    type: 'collapsible',
    icon: 'project-document.svg',
    role: {
      roles: ['employee'],
      right: ['H1953'],
    },
    children: [
      {
        id: 'Project-document',
        title: 'Project Document',
        type: 'item',
        icon: 'project-document.svg',
        url: '/i-team/sprint-description/sprint-description',
        role: {
          roles: ['employee'],
          right: 'H1953',
        },
      },
    ],
  },
  {
    id: 'customer-dashboard',
    title: 'Dashboard',
    type: 'item',
    icon: 'uat.svg',
    url: '/i-team/uat/customer-dashboard',
    role: {
      roles: ['customer'],
      right: '',
    },
  },
  {
    id: 'customer-sessions',
    title: 'Phase',
    type: 'item',
    icon: 'tickets.svg',
    url: '/i-team/uat/customer-sessions',
    role: {
      roles: ['customer'],
      right: '',
    },
  },
  {
    id: 'change-request',
    title: 'Change Request',
    type: 'collapsible',
    icon: 'policies.svg',
    role: {
      roles: ['employee'],
      right: ['H1955'],
    },
    children: [
      {
        id: 'change-requests-list',
        title: 'Approvals',
        type: 'item',
        icon: 'policies.svg',
        url: '/i-team/change-requests/approvals',
        role: {
          roles: ['employee'],
          right: 'H1958',
        },
      },
      {
        id: 'hierarchy-change-requests',
        title: 'Hierarchy',
        type: 'item',
        icon: 'Team_permission.svg',
        url: '/i-team/change-requests/hierarchy',
        role: {
          roles: ['employee'],
          right: 'H1959',
        },
      },
    ],
  },
];
